export async function blobToBase64(blobPromise)
{
	return await blobPromise.then(blob =>
		new Promise(onSuccess => {
			let reader = new FileReader();
			reader.onload = function () { onSuccess(this.result); };
			reader.readAsDataURL(blob);
		})
	);
}